import React from 'react';
import Slider from 'slider';
import {UploadImage} from 'components/UI/Image';
import style from './style.scss';

class ListProductDetailImage extends React.Component {
  constructor(props, context) {
    super(props, context);
  }

  render() {
    const settings = {
      customPaging: (index) => {
        return <a><UploadImage transform="crop" type="PRODUCT" width="80" height="80" image={this.props.images[index]} /></a>
      },
      dots: true,
      fade: true,
      dotsClass: 'slick-dots slick-thumb',
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      responsive: [{
        breakpoint: 651,
        settings: {
          dots: false,
          arrows: false
        }
      }]
    };
    return (
      <section className='product-detail-slider'>
        <Slider {...settings}>
          {
            this.props.images.map((item,i) => {
              return (
                <div className='product-detail-item'>
                  <UploadImage transform="crop" type="PRODUCT" width="550" height="325" image={item} />
                </div>
              );
            })
          }
        </Slider>
      </section>
    );
  }
}

export default ListProductDetailImage;



// WEBPACK FOOTER //
// ./components/product-detail/sub-view/list-product-detail-image/ListProductDetailImage.jsx